(function(){
  /* 목록 카드를 옆으로 밀면 «다음 컬러» 로 간다 — 그림까지 한국몰과 같게.

     ★ 값은 한국 목록 페이지의 코드를 원문으로 읽어 그대로 옮겼다 (함수 「밀기」):
        끌기 시작  |dx| > 12  그리고  |dx| > |dy| × 1.4
        넘김 확정  손 뗄 때 |dx| >= 40
        그림       새 사진 translate3d(±100%,0,0) → 0
                   옛 사진 복제본은 반대쪽 ∓100%
                   둘 다  transition: transform .3s ease
        정리       340ms 뒤 · 겹침은 data-mj-sliding 자물쇠로 막는다
     예전에는 문턱 30 하나뿐이었고 미끄러짐이 없었다(테마의 0.1초 겹침만).

     컬러를 «눌러» 바꿀 때도 같은 그림이 나온다 — 한국이 그렇다. */
  var DRAG = 12, RATIO = 1.4, GO = 40, EASE = 'transform .3s ease', CLEAN = 340;

  function swatches(card){
    return [].slice.call(card.querySelectorAll('.product-block-options__item'));
  }
  function nowIndex(sw){
    /* ★ 2026-09-01 — «지금 떠 있는 색» 을 먼저 본다.
       왜: 목록에서 한 상품을 색깔별 카드로 쪼갠 뒤(collection_card_variants),
       카멜 카드에는 aria-current 도 mj-sw-on 도 붙지 않는다. 그래서 아래
       `return 0` 으로 떨어져 «어떤 색 카드든 늘 1번에서» 출발했다.
       대표님이 세 번 지적하신 바로 그 증상이다 [2026-09-01 430px 실측].
       --mj-on 은 mjade-card-color.js 가 «화면에 떠 있는 사진» 을 따라 옮긴다.
       즉 눈에 보이는 것이 기준이 된다 — 그래서 이것을 먼저 본다. */
    for (var k = 0; k < sw.length; k++){
      if (sw[k].classList.contains('product-block-options__item--mj-on')) return k;
    }
    for (var k = 0; k < sw.length; k++){
      if (sw[k].getAttribute('aria-current') === 'true' ||
          sw[k].classList.contains('mj-sw-on')) return k;
    }
    return 0;
  }
  /* ★ 2026-08-29 — 펼쳐 둔 컬러 줄은 «한 번에 하나만» (대표님 지시).
     카드를 만지는 순간 다른 카드의 펼침을 닫는다. 접기는 목록 스크립트가
     열어 준 창구(__mjRailCollapse)로 부른다 — 접는 규칙을 두 곳에 두지 않는다. */
  function soloRail(card){
    if (!window.__mjRailCollapse) return;
    var mine = card.querySelector('.product-block-options--swatch');
    var open = document.querySelectorAll(
      '.product-block-options--swatch[data-mj-open="1"]');
    for (var i = 0; i < open.length; i++){
      if (open[i] === mine) continue;
      try { window.__mjRailCollapse(open[i]); } catch (e) {}
    }
  }
  /* ★ 2026-08-29 — 컬러가 바뀌면 «아래 컬러 줄» 이 따라 움직인다.
     펼친 뒤에는 줄 내용이 259px 인데 보이는 폭이 174px 이라, 밀지 않으면
     5·6·7번째 컬러가 화면 밖에 있었다 [실측]. 고른 칸을 줄 가운데로 놓는다.
     넘치지 않는 줄은 손대지 않고, 양 끝에서는 끝에 붙인다. */
  function follow(card){
    var rail = card.querySelector('.product-block-options--swatch');
    if (!rail) return;
    var inner = rail.querySelector('.product-block-options__inner');
    if (!inner) return;
    var max = inner.scrollWidth - inner.clientWidth;
    if (max <= 1) return;                 /* 넘치지 않으면 가만둔다 */
    var sw = swatches(card), el = sw[nowIndex(sw)];
    if (!el || el.offsetWidth < 2) return;
    var er = el.getBoundingClientRect(), ir = inner.getBoundingClientRect();
    var want = inner.scrollLeft + (er.left - ir.left)
             - (ir.width - er.width) / 2;
    want = Math.max(0, Math.min(max, want));
    if (Math.abs(want - inner.scrollLeft) < 2) return;   /* 이미 맞으면 그대로 */
    try { inner.scrollTo({ left: want, behavior: 'smooth' }); }
    catch (e) { inner.scrollLeft = want; }
  }
  /* 지금 «보이는» 사진 한 장. 복제본과 크기 0 인 것은 뺀다. */
  function shown(cont, skip){
    var im = cont.querySelectorAll('.product-block__image');
    for (var i = 0; i < im.length; i++){
      var e = im[i];
      if (e === skip || e.classList.contains('mj-card-slide-old')) continue;
      if (e.offsetWidth < 4 || e.offsetHeight < 4) continue;
      if (parseFloat(getComputedStyle(e).opacity || '1') < 0.5) continue;
      return e;
    }
    return null;
  }
  function slide(card, dir, doIt){
    var cont = card.querySelector('.image-cont');
    if (!cont || card.getAttribute('data-mj-sliding') === '1'){ doIt(); return; }
    var cur = shown(cont);
    if (!cur){ doIt(); return; }
    card.setAttribute('data-mj-sliding', '1');
    var old = cur.cloneNode(true);
    old.className = cur.className + ' mj-card-slide-old';
    old.style.opacity = '1';
    old.style.transition = 'none';
    old.style.transform = 'translate3d(0,0,0)';
    /* ★ MJade 2026-09-17 — 일본 원문에 없는 여섯 줄. 미국에서 실제로 난 증상을 막는다.
       떠 있는 사진은 늘 «1번(primary)» 인데, 1번에는 자리 규칙이 없어 «흐름 안» 에 있다
       (테마 main.css: --secondary 만 position:absolute).
       그래서 복제본을 그냥 붙이면 흐름에 한 칸이 더 생겨 카드가 아래로 늘어나고,
       그 자리에 사진이 원래 크기로 나타났다 — 「이상한 큰 사진」.
       .image-cont 는 이미 position:relative 라, 복제본만 겹쳐 두면 높이가 안 변한다. */
    old.style.position = 'absolute';
    old.style.top = '0';
    old.style.left = '0';
    old.style.width = '100%';
    old.style.height = '100%';
    old.style.zIndex = '2';
    cont.appendChild(old);
    /* * 2026-09-01 — 미끄러지는 동안 «딱 두 장만» 보이게 못 박는다.
       한국몰 원문(m.mjade.co.kr 목록, 함수 「밀기」)은 사진 요소가 «하나뿐»이라
       src 만 갈아끼운다. 그래서 겹칠 것이 복제본 1장 + 원본 1장뿐이다.
       쇼피파이는 색마다 요소가 따로 있고 테마가 그 사이를 opacity 로 넘긴다.
       그 페이드가 우리 밀기와 겹쳐 잔상으로 보였다 [대표님 지적 2026-09-01].
       잠금이 걸린 동안에는 복제본(옛)과 들어오는 것(mj-slide-in)만 보인다. */
    cont.classList.add('mj-slide-lock');
    doIt();                                  /* 컬러를 실제로 바꾼다 */
    var out = (dir >= 0 ? 100 : -100), t0 = Date.now(), nw = null;
    /* * 2026-09-01 — «반드시 풀리는» 안전장치.
       아래 wait() 는 requestAnimationFrame 으로 돈다. 탭을 벗어나거나 창이
       가려지면 rAF 가 멈춘다 — 그러면 done() 이 영원히 안 불려 잠금이 걸린 채
       남고 카드가 «빈칸» 이 된다 [2026-09-01 실제로 재현됨].
       그래서 시계로도 한 번 더 건다. 둘 중 먼저 오는 쪽이 끝낸다.
       done() 은 두 번 불려도 한 번만 돈다. */
    var mjEnded = false;
    var mjGuard = setTimeout(function(){ done(); }, 900);
    function done(){
      if (mjEnded) return;
      mjEnded = true;
      clearTimeout(mjGuard);
      if (old.parentNode) old.parentNode.removeChild(old);
      cont.classList.remove('mj-slide-lock');
      if (nw){ nw.style.transition = ''; nw.style.transform = '';
               nw.style.opacity = ''; nw.classList.remove('mj-slide-in'); }
      if (cur) cur.style.opacity = '';
      card.removeAttribute('data-mj-sliding');
      follow(card);            /* 펼쳐지며 자리가 바뀌었을 수 있으니 한 번 더 */
    }
    (function wait(){
      /* * 2026-09-01 — «떠 있는 사진» 을 투명도가 아니라 클래스로 찾는다.
         왜: shown() 은 opacity 0.5 를 넘겨야 사진으로 쳤다. 그래서 새 사진이
         «제자리에서» 반쯤 나타난 뒤에야 밀기가 시작됐다. 대표님이 보신
         「2번째 이미지가 살짝 보이고 0.5초 뒤 다음 컬러로 넘어감」이 이것이다.
         실측(모바일 504px): 새 사진이 x0 자리에서 op0.22 → 1 로 «130ms 동안»
         옛 사진과 겹쳐 보였고, 163ms 에야 오른쪽 밖으로 튀어 밀려 들어왔다.
         --active 는 테마가 즉시 바꾸므로 첫 프레임에 잡힌다 — 겹침이 사라진다.
         (못 찾으면 예전 방식으로 되돌아간다) */
      nw = cont.querySelector('.product-block__image--active:not(.mj-card-slide-old)')
           || shown(cont, old);
      /* 테마가 사진을 바꿔 끼울 때까지 기다린다 (최대 260ms) */
      if (mjEnded) return;
      if ((!nw || nw === cur) && Date.now() - t0 < 260){
        /* rAF 가 멈춘 상황(숨은 탭)에서도 이어지도록 시계로도 건다 */
        requestAnimationFrame(wait);
        setTimeout(wait, 32);
        return;
      }
      if (cont.querySelector('.mj-slide-in')) return;   /* 이미 처리했다 */
      if (!nw){ done(); return; }
      /* ★ 2026-09-02 — «흰색 깜빡임» 을 없앤다.
         왜: 다른 색 사진은 손이 닿은 뒤에야 받기 시작한다(카드를 가볍게 하려고 자료로
         싣고 그때 만든다). 밀기는 손을 뗀 직후 시작하므로, 아직 안 받아진 사진을 들고
         미끄러지면 그 자리에 빈 상자(흰 칸)가 지나간다 [대표님 지적 2026-09-02].
         잠금 중에는 «옛 복제본과 들어오는 것» 만 보이게 못 박아 둔 탓에 더 도드라진다.
         고침: 들어올 사진이 실제로 그려질 수 있을 때까지 기다렸다 시작한다.
         그동안 옛 사진이 그대로 떠 있으므로 빈 칸이 안 생긴다.
         최대 400ms 만 기다리고, 그 안에 못 받으면 예전처럼 진행한다
         (900ms 안전장치가 어차피 잠금을 푼다). */
      var nwImg = nw.querySelector('img');
      if (nwImg && !(nwImg.complete && nwImg.naturalWidth > 0)
          && Date.now() - t0 < 400){
        requestAnimationFrame(wait);
        setTimeout(wait, 32);
        return;
      }
      follow(card);            /* 사진이 바뀌는 순간 아래 줄도 같이 움직인다 */
      /* * 2026-09-01 — 옛 사진 «원본» 은 여기서 감춘다.
         밀려 나가는 것은 복제본이다. 원본을 그대로 두면 제자리(x0)에 130ms
         더 남아, 복제본이 비켜난 자리에 같은 사진이 멈춰 있는 것처럼 보였다
         [2026-09-01 실측]. nw 를 확정한 뒤에 감추므로, 색이 안 바뀐 경우엔
         감추지 않는다(빈 칸이 생기지 않는다). done() 에서 되돌린다. */
      cur.style.opacity = '0';
      nw.classList.add('mj-slide-in');       /* 잠금 중에도 이것만 보인다 */
      nw.style.transition = 'none';
      nw.style.opacity = '1';        /* 페이드와 밀기가 겹치지 않게 */
      nw.style.transform = 'translate3d(' + out + '%,0,0)';
      void nw.offsetWidth;                   /* 리플로우 강제 — 없으면 안 움직인다 */
      nw.style.transition = EASE;
      nw.style.transform = 'translate3d(0,0,0)';
      old.style.transition = EASE;
      old.style.transform = 'translate3d(' + (-out) + '%,0,0)';
      setTimeout(done, CLEAN);
    })();
  }
  function go(card, dir){
    var sw = swatches(card);
    if (sw.length < 2) return;
    soloRail(card);          /* 다른 카드에 펼쳐 둔 줄을 먼저 닫는다 */
    var n = (nowIndex(sw) + dir + sw.length) % sw.length;   /* 끝에서 처음으로 */
    var t = sw[n];
    if (!t) return;
    /* ★ 한국과 같은 규칙 — 넘어갈 색이 «감춰져 있으면» 먼저 «+N more» 를 펼친다.
       (한국 원문: 목[다음] 이 data-mj-hide 면 .mj-sw-more 를 click)
       일본은 mjade-best-sellers-mobile.js 가 3개만 두고 나머지에 인라인
       display:none 을 준다. 그 스크립트의 펼치기를 그대로 부른다. */
    if (t.offsetWidth < 2 || t.offsetHeight < 2){
      var more = card.querySelector('.product-block-options__more-label');
      if (more) more.click();
    }
    slide(card, dir, function(){
      (t.querySelector('a,button,label') || t).click();
    });
  }
  /* 컬러를 «눌러» 바꿀 때도 미끄러지게 — 테마 처리보다 «먼저» 사진을 떠 둔다 */
  document.addEventListener('click', function(e){
    var it = e.target && e.target.closest &&
             e.target.closest('.product-block-options__item');
    if (!it) return;
    var card = it.closest('.product-block');
    if (!card) return;
    var sw = swatches(card), n = sw.indexOf(it), i = nowIndex(sw);
    if (n < 0 || n === i) return;
    soloRail(card);          /* 다른 카드에 펼쳐 둔 줄을 먼저 닫는다 */
    slide(card, n > i ? 1 : -1, function(){});
  }, true);

  /* * 2026-09-01 — 테마 «자기 밀기» 를 끈다. 한 번 밀면 한 칸만 간다.
     테마도 목록 카드에 밀기를 갖고 있다 (main.js, ProductBlock.initImagePagination):
       touchmove 에서 |dx| > 25 가 되면 그 자리에서 incrementActiveImage(±1)
     즉 «손을 떼기도 전에» 사진이 한 칸 넘어간다. 그리고 손을 떼면 우리 go() 가
     또 한 칸 간다 — 그래서 «한 번에 두 칸» 이었다. 게다가 테마 쪽 한 칸은
     밀기 없이 제자리에서 바뀌므로 잔상처럼 보였다 [대표님 지적 2026-09-01].

     끄는 방법: 테마는 전역 스위치 theme.productBlockTouchTracking 이 참일 때만
     움직인다. document 의 «가로채기 단계» 에서 그것을 꺼 둔다 — 가로채기는 언제나
     대상의 처리기보다 먼저 돌기 때문에, 누가 먼저 등록됐든 상관없이 확실하다.
     (전에 touchstart 에서 끄려 했다면 등록 순서에 따라 안 먹었을 것이다.)

     ★ 색이 하나뿐인 카드는 우리 밀기가 아무것도 안 하므로 «건드리지 않는다».
       그런 카드는 예전처럼 테마가 사진을 넘긴다. */
  document.addEventListener('touchmove', function(e){
    var el = e.target;
    if (!el || !el.closest) return;
    var card = el.closest('.product-block');
    if (!card) return;
    if (swatches(card).length < 2) return;      /* 색 하나 → 테마 그대로 */
    if (window.theme) window.theme.productBlockTouchTracking = false;
  }, true);

  function bind(card){
    if (card.__mjSwipe) return;
    card.__mjSwipe = 1;
    var host = card.querySelector('.image-cont') || card;
    var x0 = 0, y0 = 0, live = false, drag = false;
    host.addEventListener('touchstart', function(e){
      var t = e.touches && e.touches[0];
      if (!t || e.touches.length !== 1){ live = false; return; }
      x0 = t.clientX; y0 = t.clientY; drag = false; live = true;
    }, {passive:true});
    host.addEventListener('touchmove', function(e){
      if (!live) return;
      var t = e.touches && e.touches[0];
      if (!t) return;
      var dx = t.clientX - x0, dy = t.clientY - y0;
      if (!drag && Math.abs(dx) > DRAG && Math.abs(dx) > Math.abs(dy) * RATIO)
        drag = true;
      if (drag && e.cancelable) e.preventDefault();   /* 세로 스크롤과 안 싸우게 */
    }, {passive:false});
    host.addEventListener('touchend', function(e){
      if (!live) return;
      live = false;
      var t = e.changedTouches && e.changedTouches[0];
      var dx = t ? t.clientX - x0 : 0;
      if (!drag || Math.abs(dx) < GO){ drag = false; return; }
      drag = false;
      go(card, dx < 0 ? 1 : -1);
    }, {passive:true});
  }
  function scan(){
    var cards = document.querySelectorAll('.product-block');
    for (var i = 0; i < cards.length; i++) bind(cards[i]);
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  /* 미끄러질 때 복제본을 넣고 빼므로, 그때마다 훑지 않도록 잠깐 모아서 한 번만 */
  if (window.MutationObserver){
    new MutationObserver(function(){
      clearTimeout(window.__mjCardT);
      window.__mjCardT = setTimeout(scan, 120);
    }).observe(document.body, {childList:true, subtree:true});
  }
})();
